import { FC, useState } from "react";
import { useDynamicRouting } from "shared/hooks/useDynamicRouting";
import { CUSTOMER_SERVICES_CENTRE } from "shared/routes/paths";
import { useMainLayoutPage } from "../../context";
import MenuBar from "./components/MenuBar";
import { NavItemCollapser } from "./components/NavItem/components/NavItemCollapser";
import { NavItemLink } from "./components/NavItem/components/NavItemLink";
import { StyledMenuBarContainer, StyledTitle, StyledDivider } from "./styled";

const NavigationBar: FC = () => {
  const [isMenuBarExpanded, setIsMenuBarExpanded] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const { allowedRoutes } = useDynamicRouting();
  const { unreadTicketsMessagesCount } = useMainLayoutPage();

  const toggleMenuBar = () => {
    setIsMenuBarExpanded(!isMenuBarExpanded);
    setTimeout(() => setIsHovered(false), 0);
  };

  const formattedAllowedRoutes = allowedRoutes.map((route) => {
    if (route.pathname === CUSTOMER_SERVICES_CENTRE) {
      return {
        ...route,
        unreadCount: unreadTicketsMessagesCount,
      };
    }

    return route;
  });

  const isExpanded = isMenuBarExpanded || isHovered;

  return (
    <StyledMenuBarContainer
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      expanded={isMenuBarExpanded}
    >
      <MenuBar
        isMenuBarExpanded={isMenuBarExpanded}
        isHovered={isHovered}
        toggleMenuBar={toggleMenuBar}
      >
        {isMenuBarExpanded || isHovered ? (
          <StyledTitle>General</StyledTitle>
        ) : (
          <StyledDivider />
        )}
        {formattedAllowedRoutes
          .filter(({ category }) => category === "general")
          .map(
            ({
              pathname,
              title,
              Icon,
              elements,
              handleAction,
              isLoadingAction,
              unreadCount,
            }) => (
              <div key={pathname}>
                {elements ? (
                  <NavItemCollapser
                    Icon={Icon}
                    title={title ?? ""}
                    subItems={elements.filter((item) => !item.isHiddenInNavBar)}
                    isLoadingRefetch={Boolean(isLoadingAction)}
                    handleRefetchSybItems={handleAction}
                    isExpanded={isExpanded}
                  />
                ) : (
                  <NavItemLink
                    isExpanded={isExpanded}
                    key={pathname}
                    title={title}
                    pathname={pathname}
                    Icon={Icon}
                    unreadCount={unreadCount}
                  />
                )}
              </div>
            ),
          )}

        {isMenuBarExpanded || isHovered ? (
          <StyledTitle>Support & Management</StyledTitle>
        ) : (
          <StyledDivider />
        )}
        {formattedAllowedRoutes
          .filter(({ category }) => category === "support")
          .map(
            ({
              pathname,
              title,
              Icon,
              elements,
              handleAction,
              isLoadingAction,
              unreadCount,
            }) => (
              <div key={pathname}>
                {elements ? (
                  <NavItemCollapser
                    Icon={Icon}
                    title={title ?? ""}
                    subItems={elements.filter((item) => !item.isHiddenInNavBar)}
                    isLoadingRefetch={Boolean(isLoadingAction)}
                    handleRefetchSybItems={handleAction}
                    isExpanded={isExpanded}
                  />
                ) : (
                  <NavItemLink
                    isExpanded={isExpanded}
                    key={pathname}
                    title={title}
                    pathname={pathname}
                    Icon={Icon}
                    unreadCount={unreadCount}
                  />
                )}
              </div>
            ),
          )}

        {isMenuBarExpanded || isHovered ? (
          <StyledTitle>Admin Tools</StyledTitle>
        ) : (
          <StyledDivider />
        )}
        {formattedAllowedRoutes
          .filter(({ category }) => category === "admin")
          .map(
            ({
              pathname,
              title,
              Icon,
              elements,
              handleAction,
              isLoadingAction,
              unreadCount,
            }) => (
              <div key={pathname}>
                {elements ? (
                  <NavItemCollapser
                    Icon={Icon}
                    title={title ?? ""}
                    subItems={elements.filter((item) => !item.isHiddenInNavBar)}
                    isLoadingRefetch={Boolean(isLoadingAction)}
                    handleRefetchSybItems={handleAction}
                    isExpanded={isExpanded}
                  />
                ) : (
                  <NavItemLink
                    isExpanded={isExpanded}
                    key={pathname}
                    title={title}
                    pathname={pathname}
                    Icon={Icon}
                    unreadCount={unreadCount}
                  />
                )}
              </div>
            ),
          )}
      </MenuBar>
    </StyledMenuBarContainer>
  );
};

export default NavigationBar;
